var map = {
	"./fonts/RobotoCondensed-Bold.ttf": 923,
	"./fonts/RobotoCondensed-BoldItalic.ttf": 4995,
	"./fonts/RobotoCondensed-Italic.ttf": 1983,
	"./fonts/RobotoCondensed-Light.ttf": 4090,
	"./fonts/RobotoCondensed-LightItalic.ttf": 1978,
	"./fonts/RobotoCondensed-Regular.ttf": 8479,
	"./logos/CIESAS.png": 6709,
	"./logos/FazAFaz.png": 1149,
	"./logos/Ibero.png": 9795,
	"./logos/InterNeta.png": 3791,
	"./logos/Invisible.png": 2494,
	"./logos/LAIS.png": 1388,
	"./logos/LANMO.png": 267,
	"./logos/LAVSAN.png": 4690,
	"./logos/LAV_UAM-I.png": 7935,
	"./logos/LAbIIA.png": 955,
	"./logos/LaMA.png": 81,
	"./logos/Lab_i-CreA.png": 533,
	"./logos/Secundaria59.png": 3687,
	"./logos/Tlacuilo.png": 5390,
	"./logos/UCEMICH.png": 2004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6875;